import { apiPost, ApiError } from '.';

/**
 * Запрос серий продуктов
 */
const apiEmailTemplateRemove = async (templateId) => {
  return apiPost('/email/template/remove', {
    templateId,
  });
};
export default apiEmailTemplateRemove;
